import { getTheme } from "PFCore/get_theme";

export const injectTheme = (theme?: string) => {
  const themeVars = getTheme(theme);

  Object.keys(themeVars).forEach((key) => document.documentElement.style.setProperty(key, themeVars[key]));
};
